import React  from 'react';
import { Buttons } from '../../elements/ui/index';
import Ionicon from "react-ionicons";

export const Headline = ( props ) => {
    const { body, buttonHandlers, guestMode } = props;
    return (
        <div>
            { body && <span className="user-info">{ body }</span> }
            {/*show when not in guestMode*/}
            { !guestMode && <Buttons.HOCButton
                text={ body ? <Ionicon icon="ion-edit"/> : <em>Add headline...</em>}
                icon=""
                handleEditing={ buttonHandlers.handleEditing }
            /> }
            {/*//////////////////////////*/}
        </div>
    )
};

export default Headline;


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/header/Headline.js